module.exports = __webpack_public_path__ + "images/22dfe60ea4e7c7d349d0b5ff3417f7c3energy.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/energy.png
// module id = hD8Q
// module chunks = 0